export default __webpack_public_path__ + "static/media/diesel-logo.993fb20b.jpeg";